import { Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { IHyperlinkToSave } from "src/app/interfaces";
import { LogClass, Logger } from "src/app/logger";
import { SubSink } from "subsink";

@Component({
  selector: "circ-add-hyperlink",
  templateUrl: "./add-hyperlink.component.html",
  styleUrls: ["./add-hyperlink.component.scss"],
  standalone: false
})
@LogClass({ source: "AddHyperlinkComponent" })
export class AddHyperlinkComponent implements OnDestroy {
  @Output() public add = new EventEmitter<IHyperlinkToSave>();
  public name: string = '';
  public errorText: string;
  public target: string = '';
  private logger: Logger;
  private subscriptions = new SubSink();

  constructor() {
    this.logger.debug("ctor");
  }

  public addHyperlink(): void {
    this.errorText = "";
    if (!this.name || !this.target) {
      this.errorText = "step_link_error";
      return;
    }
    if (!this.isValidURL(this.target)) {
      this.errorText = "step_link_invalid";
      return;
    }
    const doc: IHyperlinkToSave = {
      name: this.name,
      uri: this.target
    };

    this.add.emit(doc);
    this.name = '';
    this.target = '';
  }

  public isValidURL(string): boolean {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
